const payment = [
  'Cash',
  'Credit Card',
  'Other'
]

const states = [
  'Delivery Instore',
  'En Route',
  'Delivered',
  'TA Instore',
  'TA Collected'
]

const stateClasses = [
  'td-delivery-instore',
  'td-en-route',
  'td-delivered',
  'td-ta-instore',
  'td-ta-collected'
]

export default {
  tableFields: [
    {
      name: 'daily_no',
      sortField: 'daily_no',
      title: 'ID'
    },
    {
      name: 'alt_order_id',
      title: 'AltOrderID'
    },
    {
      name: 'order_time',
      sortField: 'order_time',
      title: 'Time',
      callback: utc => new Date(utc).toString().substr(4, 20)
    },
    {
      name: 'address',
      title: 'Address'
    },
    {
      name: 'store',
      title: 'Store'
    },
    {
      name: 'customer',
      title: 'Customer'
    },
    {
      name: 'phone',
      title: 'Phone',
      callback: phone => phone.replace(/^00/g, '')
    },
    {
      name: 'carrier',
      title: 'Carrier'
    },
    {
      name: '__component:items-picker',
      title: 'Items'
    },
    {
      name: 'total',
      title: 'Total',
      callback: (value) => value.toFixed(2)
    },
    {
      name: 'payment_method',
      title: 'Payment',
      callback: value => payment[value]
    },
    {
      name: '__component:map-picker',
      title: 'Track'
    },
    {
      name: 'status',
      title: 'Status',
      dataClass: 'data-status-table',
      titleClass: 'title-status-table',
      callback: 'getStatus'
    },
    {
      name: 'is_timed',
      title: 'Is Timed',
      dataClass: 'text-center',
      titleClass: 'text-center',
      callback: (value) => value ? `<i class="fa fa-check"></i>` : ''
    },
    {
      name: 'state',
      title: 'State',
      visible: false,
      callback: v => `<span class="${stateClasses[v]}">${states[v]}</span>`
    },
    {
      name: 'waiting',
      title: 'Waiting',
      callback: v => `${v}min`
    },
    {
      name: 'over_30',
      title: 'Over 30',
      dataClass: 'text-center',
      titleClass: 'text-center',
      callback: (value) => value ? `<i class="fa fa-frown-o"></i>` : ''
    },
  ],
  sortFunctions: {
    'order_id': function (item1, item2) {
      return item1 >= item2 ? 1 : -1
    },
    'order_time': function (item1, item2) {
      return item1 >= item2 ? 1 : -1
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuestic-theme/vuestic-components/vuestic-datatable/data/fields-definition.js